import { type Transition } from 'motion/react'

export type DiscountProgressVariant = 'tinted-pill' | 'white'

const EASE: [number, number, number, number] = [0.4, 0, 0.2, 1]

// A tier crossing ("leg") has two beats: the fill runs to the marker, then the
// marker slides over carrying the fill with it.
export const FILL_DURATION = 0.28
export const MARKER_DURATION = 0.32
export const LEG_DURATION = FILL_DURATION + MARKER_DURATION

export const PROGRESS_TRANSITION: Transition = {
  duration: FILL_DURATION,
  ease: EASE,
}

export const MARKER_TRANSITION: Transition = {
  duration: MARKER_DURATION,
  ease: EASE,
  delay: FILL_DURATION,
}

export const CHIP_ENTER_TRANSITION: Transition = { duration: 0.45, ease: EASE }
export const CHIP_EXIT_TRANSITION: Transition = { duration: 0.2, ease: EASE }
export const CHIP_SHIFT_TRANSITION: Transition = {
  duration: MARKER_DURATION,
  ease: EASE,
}
export const CHIP_CONTENT_TRANSITION: Transition = {
  duration: 0.25,
  ease: EASE,
}

export const LEG_TRANSITION: Transition = {
  duration: LEG_DURATION,
  times: [0, FILL_DURATION / LEG_DURATION, 1],
  ease: [EASE, EASE],
}

export const INSTANT_TRANSITION: Transition = { duration: 0 }
